import { render, staticRenderFns } from "./TintometricoIntegracao.vue?vue&type=template&id=7020a8a7"
import script from "./TintometricoIntegracao.vue?vue&type=script&lang=js"
export * from "./TintometricoIntegracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports